import Icon from 'components/shared/Icon/Icon';

import DrAvatar from './lib/components/DrAvatar';
import SlideHeader from './lib/components/SlideHeader';
import SpeechBubble from './lib/components/SpeechBubble';

const ServicesPage = ({ estimate }) => {
  const services = estimate?.services ?? [];

  return (
    <div className="flex flex-col gap-5">
      <SlideHeader title="Services" />

      <SpeechBubble variant="default">
        You should know what your visit will cost before it happens. Here's our Good Faith Estimate
        (GFE) — an upfront estimate of your services, in line with the federal No Surprises Act.
      </SpeechBubble>

      <div className="flex gap-4 sm:flex-col">
        <div className="flex-1 overflow-hidden rounded-xl border border-solid border-neutral-200 bg-white shadow-sm sm:w-full">
          <div className="bg-neutral-50 px-4 py-2">
            <p className="text-sm font-600 uppercase tracking-wider text-neutral-500">
              Your Services
            </p>
          </div>
          <div className="flex flex-col gap-2 p-4">
            {services.length === 0 && (
              <span className="text-sm text-neutral-400">
                Your services will be listed here once they're added to your visit.
              </span>
            )}
            {services.map((service, index) => (
              <div
                key={`${service.service_id ?? service.code ?? 'service'}-${index}`}
                className="flex items-center gap-3">
                <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-primary-500 shadow-sm">
                  <Icon icon="tick-circle-mono" size={14} color="white" />
                </div>
                <span className="flex-1 text-sm font-500 text-primary-900">
                  {service.name || 'Service'}
                </span>
                <span className="rounded bg-primary-50 px-2 py-0.5 text-sm font-600 text-primary-600">
                  {service.code || '—'}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-1 flex-col items-center gap-3 sm:w-full">
          <DrAvatar size="medium" variant={2} />
          <SpeechBubble variant="dark" className="text-sm">
            These estimates come from real-time benefits info from your insurance, plus our team's
            read on the care you'll likely need today.
          </SpeechBubble>
        </div>
      </div>

      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-b from-[#E6F7FF] to-[#F0FAFF] px-6 py-5">
        <div className="absolute -right-4 bottom-0 opacity-15">
          <DrAvatar size="large" variant={3} />
        </div>
        <p className="relative z-10 text-sm leading-[1.8] text-neutral-700">
          A few things can change this total. If your insurance updates or your treatment shifts
          during your visit, we'll adjust the bill — you'll see any difference as a credit or charge
          after your visit.
        </p>
      </div>
    </div>
  );
};

export default ServicesPage;
